import { format, parseISO } from 'date-fns'
import { ExternalLink } from 'lucide-react'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv } from '@/components/relatorios/reportUtils'
import { useAiAppointmentsReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'

export default function AgendamentosIaReport() {
  const [range, setRange] = useReportDateRange()
  const report = useAiAppointmentsReport(range)
  const matched = report.data.filter((row) => row.contactId).length

  return (
    <ReportShell
      title="Agendamentos que a IA fez"
      description="Eventos lidos ao vivo do Google Calendar e vinculados pelo telefone."
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={report.data.length === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('agendamentos-ia', report.data, [
        { label: 'Início', value: (row) => row.start },
        { label: 'Fim', value: (row) => row.end },
        { label: 'Assistente', value: (row) => row.assistant },
        { label: 'Evento', value: (row) => row.title },
        { label: 'Contato', value: (row) => row.contact },
        { label: 'Telefone', value: (row) => row.phone },
        { label: 'Link', value: (row) => row.htmlLink },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label="Agendamentos da IA" value={report.data.length} />
        <ReportKpiCard label="Contatos vinculados" value={matched} />
      </div>
      <ReportTable
        rows={report.data}
        rowKey={(row, index) => `${row.assistant}-${row.eventId}-${index}`}
        columns={[
          { key: 'start', label: 'Data e hora', render: (row) => format(parseISO(row.start), 'dd/MM/yyyy HH:mm') },
          { key: 'assistant', label: 'Assistente', render: (row) => row.assistant },
          { key: 'title', label: 'Evento', render: (row) => row.title },
          { key: 'contact', label: 'Contato', render: (row) => row.contact },
          { key: 'phone', label: 'Telefone', render: (row) => row.phone },
          {
            key: 'link',
            label: '',
            align: 'right',
            render: (row) => row.htmlLink ? (
              <a href={row.htmlLink} target="_blank" rel="noreferrer" className="inline-flex text-primary" aria-label="Abrir evento">
                <ExternalLink className="h-4 w-4" />
              </a>
            ) : null,
          },
        ]}
      />
    </ReportShell>
  )
}
